import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Card, CardBody, FormGroup, Modal, ModalHeader, Button, ModalBody, ModalFooter, Label, Table, Input, Spinner } from 'reactstrap';
import axios from 'axios';
import { FaChevronLeft } from 'react-icons/fa';
import uuid from 'react-uuid';
import { FaMinus, FaPlus, FaUserPlus, FaCheck } from 'react-icons/fa';
import "../ExternalOrganisation/ExternalOrganisation.css";
import toast, { Toaster } from 'react-hot-toast';
import { ToastContainer, toast as toastytoast } from 'react-toastify';
import Select, { components, ValueContainerProps } from 'react-select'; import { apiGet,apiPost } from "../Utilities/Hooks/apiWrapper";

const AccessManager = ({ handleWizardFarmChanged }) => {
    const [id, setId] = useState(''); const [showExtendItemPopup, setShowExtendItemPopup] = useState(false); const [extendItemId, setExtendItemId] = useState(0);
    const [temporaryAccess, setTemporaryAccess] = useState(false); const [monthSelect, setMonthSelect] = useState(0);
    const userRef = useRef(); const [firstName, setFirstName] = useState(''); const [surName, setSurName] = useState(''); const [userName, setUserName] = useState('');
    const [address1, setAddress1] = useState(''); const [address2, setAddress2] = useState('');
    const [city, setCity] = useState(''); const [phone, setPhone] = useState('');
    const [currentUser, setCurrentUser] = useState(false);
    const [email, setEmail] = useState(''); const [mobile, setMobile] = useState(''); const [role, setRole] = useState('');
    const [showDeleteItemPopup, setShowDeleteItemPopup] = useState(false); const [deleteItemId, setDeleteItemId] = useState(0);
    const [showInviteItemPopup, setShowInviteItemPopup] = useState(false); const [showSuccessPopup, setShowSuccessPopup] = useState(false);
    const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId")); const [showSuccessPopup1, setShowSuccessPopup1] = useState(false);
    const [farmList, setFarmList] = useState([]); const [loading, setLoading] = useState(true);
    const [farmSelect, setFarmSelect] = useState(''); const [farmUsers, setFarmUsers] = useState([]);
    //const [monthSelect, setMonthSelect] = useState(0);
    const [formErrors, setFormErrors] = useState({});
    const [emailVerified, setEmailVerified] = useState(false); const [formSuccess, setFormSuccess] = useState({});
    const [roles, setRoles] = useState([]); const [dataExists, setDataExists] = useState(false);
    const [saving, setSaving] = useState(''); const [farmSelectDisable, setFarmSelectDisable] = useState(false);
    const [userHasAccess, setUserHasAccess] = useState(false);
    const [isReturnstoPlan, setIsReturnstoPlan] = useState(false);

    const populateItemData = async () => {
        try {
            const response = await apiGet(
                '/api/settings/GetAccessManager/', {
                params: { Id: userId }
            }
            );
            setFarmList(response.data.content.farmList);
            setRoles(response.data.content.roleList);
            if (response.data.content.userFarmCount == 1) {
                setIsReturnstoPlan(true);
            }
            else {
                setIsReturnstoPlan(false);
            }
            if (response.data.content.farmList.length == 1) {
                setFarmSelect(response.data.content.farmList[0]);
                setFarmSelectDisable(true);
                if (response.data.content.farmList[0] != null) {
                    const response1 = farmChange(response.data.content.farmList[0].value);
                    toast.promise(response1, {
                        loading: 'Loading...',
                        success: 'Successfully loaded!..',
                        error: 'Error while loading data',
                    });

                }
            }
            
            setLoading(false);
        }
        catch (err) {
            if (!err?.response) {

            } else if (err.response?.status === 400) {

            } else {

            }
        }
    }

    useEffect(() => {
        populateItemData();
    }, []);

    const confirmDeleteItemPopup = async () => {
        const response = await apiGet(
            '/api/settings/RevokeUserAccess/', {
            params: { UserId: deleteItemId, FarmId: farmSelect.value, Id: userId }
        }
        );
        if (response.data.status) {
            setShowDeleteItemPopup(false)
            toast.success("User have been removed from user to property association!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
            setFarmUsers(response.data.content);
        }
        else {
            setShowDeleteItemPopup(false)
            toast.error("Error while updating...", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
        }
    }
    const confirmSuccessPopup = async () => {
        setShowSuccessPopup(true);
    }
    const confirmExtendItemPopup = async () => {

        const errors = {};
        if (monthSelect == undefined || monthSelect == null || monthSelect == 0) {
            errors.months = "Please month(s)";
        }
        setFormErrors(errors);
        if (Object.keys(errors).length == 0) {
            const response = await apiGet(
                '/api/settings/ExtendUserAccess/', {
                params: { UserId: extendItemId, FarmId: farmSelect.value, Id: userId, Months: monthSelect }
            }
            );
            if (response.data.status) {
                setShowExtendItemPopup(false)
                toast.success("Extended the user access!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                setFarmUsers(response.data.content);
            }
            else {
                setShowExtendItemPopup(false)
                toast.error("Error while updating...", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            }
        }
        else {
            return false;
        }
    }

    const confirmInviteItemPopup = async () => {
        const errors = {};
        if (temporaryAccess) {
            if (monthSelect == undefined || monthSelect == null || monthSelect == 0) {
                errors.monthSelect = "Please select month access";
            }
        }
        if (role == undefined || role == null || role == '0' || role == '') {
            errors.role = "Please select access level";
        }
        if (firstName == undefined || firstName == null || firstName == '') {
            errors.firstName = "Please select Firstname";
        }
        if (surName == undefined || surName == null || surName == '') {
            errors.surName = "Please select Surname";
        }
        setFormSuccess({});
        setFormErrors(errors);
        if (Object.keys(errors).length == 0) {
            setSaving(true);
            let form = {
                Id: id,
                FirstName: firstName,
                Surname: surName,
                Email: email,
                MobilePhone: mobile,
                Role: role,
                UserId: userId,
                FarmId: farmSelect.value,
                Months: monthSelect
            }
            const response = await apiPost(
                '/api/settings/InviteUser/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
            if (response.data.status) {
                setSaving(false);
                if (emailVerified && dataExists) {
                    setShowSuccessPopup1(true);
                }
                else {
                    setShowSuccessPopup(true);
                }
                setShowInviteItemPopup(false);
            }
            else {
                setSaving(false);
                toast.error("Error while inviting...", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
                setTimeout(() => {
                    window.location.reload(true);
                }, 3000);
            }
        }
    }

    const closeDeleteItemPopup = async () => {
        setShowDeleteItemPopup(false);
    }
    const closeSuccessPopup = async () => {
        //window.location.reload(true);
        setFarmSelect(farmSelect);
        const response = farmChange(farmSelect.value);
        toast.promise(response, {
            loading: 'Loading...',
            success: 'Successfully loaded!..',
            error: 'Error while loading data',
        });
        setShowSuccessPopup(false);
    }
    const closeSuccessPopup1 = async () => {
        //window.location.reload(true);
        setFarmSelect(farmSelect);
        const response = farmChange(farmSelect.value);
        toast.promise(response, {
            loading: 'Loading...',
            success: 'Successfully loaded!..',
            error: 'Error while loading data',
        });
        setShowSuccessPopup1(false);
    }
    const closeInviteItemPopup = async () => {
        setShowInviteItemPopup(false);
    }
    const closeExtendItemPopup = async () => {
        setShowExtendItemPopup(false);
    }
    const openDeleteItemPopup = async (id, currentUser) => {
        setDeleteItemId(id)
        setShowDeleteItemPopup(true);
        setCurrentUser(currentUser);
    }
    const openInviteItemPopup = async (e) => {
        await clearEmail();
        setShowInviteItemPopup(true);
    }
    const clearEmail = async (e) => {
        setEmail('');
        setEmailVerified(false);
        setFormErrors({});
        setFormSuccess({});
        setDataExists(false);
        setUserHasAccess(false);
    }
    const verifyEmail = async (e) => {
        if (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
            const errors = {};
            errors.email = "";
            setFormErrors(errors);
            setFormSuccess(errors);
            const response = await apiGet(
                '/api/settings/VerifyEmail/', {
                params: { Email: email, FarmId: farmSelect.value, Id: userId }
            });
            if (response.data.status) {
                if (response.data.message == 'Email is available') {
                    const errors1 = {};
                    errors1.email = "This is a new user. Please provide detail for the new user profile.";
                    setFormSuccess(errors1);
                    const errors = {};
                    errors.email = "Click INVITE to confirm invitation to access this property. Once invited, the new user will receive an email with details of their username and password to access the system.";
                    setFormErrors(errors);
                    setEmailVerified(true);
                    setDataExists(false);
                    setId('0');
                    setFirstName('');
                    setSurName('');
                    setAddress1('');
                    setAddress2('');
                    setCity('');
                    setPhone('');
                    setMobile('');
                    setRole('');
                    setMonthSelect(0);
                }
                else if (response.data.message == 'User to vineyard association is existing in the system') {
                    const errors = {};
                    errors.email = "This user already has access to this property!";
                    setFormErrors(errors);
                    setEmailVerified(false);
                    setUserHasAccess(true);
                    setId(response.data.content.id);
                    setFirstName(response.data.content.firstName);
                    setSurName(response.data.content.surname);
                }
                else {
                    const errors = {};
                    errors.email = "User located. Click INVITE to confirm this user access to this property. Once invited, this user will receive an email letting them know access to the property has been granted.";
                    setFormErrors(errors);
                    setEmailVerified(true);
                    setDataExists(true);
                    setId(response.data.content.id);
                    setFirstName(response.data.content.firstName);
                    setSurName(response.data.content.surname);
                    setAddress1(response.data.content.address1);
                    setAddress2(response.data.content.address2);
                    setCity(response.data.content.city);
                    setPhone(response.data.content.phone);
                    setMobile(response.data.content.mobilePhone);
                    setRole('');
                    setMonthSelect(0);
                }
            }
            else {
                toast.error("Error while checking...", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
                setEmailVerified(false);
            }
        }
        else {
            const errors = {};
            errors.email = "Email is not in valid format";
            setFormErrors(errors);
        }
    }
    const handleFarmChange = async (event) => {
        setFarmSelect(event);
        if (event != null) {
            const response = farmChange(event.value);
            toast.promise(response, {
                loading: 'Loading...',
                success: 'Successfully loaded!..',
                error: 'Error while loading data',
            });

        }
        else {
            setFarmUsers([]);
            //setSaveDisabled(true);
        }
    }

    const farmChange = async (farmId) => {
        const response = await apiGet(
            '/api/settings/FarmChange/', {
            params: { UserId: userId, FarmId: farmId }
        }
        );
        if (response.data.status) {
            setFarmUsers(response.data.content);
            //setSaveDisabled(false);
        }
    }

    const style = {
        table: {
            width: '100%',
            display: 'table',
            borderSpacing: 0,
            borderCollapse: 'separate',
        },
        th: {
            top: 0,
            left: 0,
            zIndex: 2,
            position: 'sticky',
            backgroundColor: '#fff',
        },
    };

    const handleSetFarm = async (id) => {
        const farmId = parseInt(id);
        try {
            const response = await apiGet(
                '/api/settings/getFarmDetail/', {
                params: { farmId: farmId, userId: userId }
            }
            );
            localStorage.setItem("defaultFarmId", JSON.stringify(id));
            localStorage.setItem("defaultFarmName", JSON.stringify(response.data.name));
            localStorage.setItem("defaultFarmUniqueId", JSON.stringify(response.data.uniqueIdentifier));
            handleWizardFarmChanged(farmId);
        } catch (err) {
            if (err?.response) {
                toast.error("No server response");
            }
        }
    }

    const handleClick = async (e) => {
        e.preventDefault(); // Prevents the default anchor behavior (e.g., navigation)
        try {
            const response = await apiGet(
                '/api/settings/GetUserById/', {
                params: { Id: userId }
            }
            );
            if (response.data != null) {
                var user = response.data.content.users.filter(x => x.id == userId);
                if (user[0].userFarmList.length == 1) {
                    await handleSetFarm(user[0].userFarmList[0].id);
                }
                else if (user[0].userFarmList.length > 0) {
                    window.open("/allfarmssummary", "_self");
                }
                else {
                    toast.error("Sorry, this user does not have any farm allocated to access. Please contact admin team", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
                }
            }
        } catch (err) {
            console.log(err);
        }
    };

    const openExtendItemPopup = async (id) => {
        setMonthSelect(0);
        setExtendItemId(id)
        setShowExtendItemPopup(true);
    }

    return (
        <div>
            <ToastContainer position="top-center" containerStyle={{ top: '50%' }} />
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Card className="my-4">
                <h2 className="card-header card-header-dark d-flex justify-content-between align-items-center">
                    Access Manager
                </h2>
                <CardBody>
                    <Row>
                        <Col>
                            <span style={{ fontSize: "18px" }}><b>See below a list of users that have access to this property. Use the buttons to revoke access or invite a new user to access the property.</b></span>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="d-flex" sm="6">
                            <FormGroup>
                                <Label className="label" for="userSelect">Select Property</Label>
                                {farmList == undefined && <p><em>Loading...</em></p>}
                                {farmList != undefined && farmList != null &&
                                    <Select style={{ zIndex: "9999" }}
                                        id="userSelectAccessManager" width="max-content"
                                        name="userSelectAccessManager"
                                        closeMenuOnSelect={true}
                                        className="dropdown"
                                        placeholder="Select property"
                                        value={farmSelect} isDisabled={farmSelectDisable}
                                        options={farmList}
                                        onChange={handleFarmChange}
                                        isClearable hideSelectedOptions={false}
                                    />
                                }
                            </FormGroup>
                        </Col>
                        <Col className="" sm="6">
                            {farmSelect != undefined && farmSelect != null && farmSelect.value != undefined && farmSelect.value != null &&
                                <>
                                    <br />
                                <Button onClick={(e) => openInviteItemPopup(e)} className="btn btn-save btn btn-success btn-sm" style={{ backgroundColor: "#198754", borderColor: "#198754", float: "right" }}>
                                        <FaUserPlus />
                                        &nbsp;Invite New
                                    </Button>
                                </>
                            }
                            {
                                isReturnstoPlan && <Button style={{ float: "right", marginRight: "10px" }} onClick={handleClick} color="success" size="sm">
                                <FaChevronLeft />Return to Plan
                                </Button>
                            }
                        </Col>
                    </Row>
                    <Row className="userFarm-tabledetails">
                        <Col>
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th style={{ width: "25%", borderWidth: "1px 1px" }} >Name</th>
                                        <th style={{ width: "22%", borderWidth: "1px 1px" }} >Email</th>
                                        <th style={{ width: "20%", borderWidth: "1px 1px" }} >Access Rights</th>
                                        <th style={{ width: "15%", borderWidth: "1px 1px" }} >Expiry</th>
                                        <th style={{ width: "15%", borderWidth: "1px 1px" }} >Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {farmUsers == undefined &&
                                        <tr><td colSpan="3" style={{ textAlign: "center" }}>Loading...</td></tr>
                                    }
                                    {farmUsers != undefined && farmUsers.length > 0 && farmUsers.map((item, idx) => (
                                        <tr key={uuid()}>
                                            <td>{item.userName}</td>
                                            <td>{item.email}</td>
                                            <td>{item.position}</td>
                                            <td>
                                                {item.expiry == '' ? '' : item.expiry}
                                            </td>
                                            <td>
                                                {!item.isExpired &&
                                                    <Button onClick={(e) => openDeleteItemPopup(item.userId, item.currentUser)} style={{ backgroundColor: "#E2401F", borderColor: "#E2401F", marginLeft: "10px" }}>
                                                        <FaMinus />
                                                        &nbsp;Revoke
                                                    </Button>
                                                }
                                                {item.isExpired &&
                                                    <Button onClick={(e) => openExtendItemPopup(item.userId)} style={{ backgroundColor: "#E2401F", borderColor: "#E2401F", marginLeft: "10px" }}>
                                                        <FaPlus />
                                                        &nbsp;Extend
                                                    </Button>
                                                }
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
            <Modal isOpen={showDeleteItemPopup}>
                <ModalHeader>Revoke Access</ModalHeader>
                <ModalBody>
                    {currentUser &&
                        <>
                            This is you! Are you sure you wish to remove the access to this property? It will require another user to grant access again.
                        </>}
                    {!currentUser &&
                        <>
                            Do you want to remove this user from user to property association?
                        </>}
                    Do you want to remove this user from user to property association?
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={confirmDeleteItemPopup}>Yes</Button>
                    <Button color="danger" onClick={closeDeleteItemPopup}>No</Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={showExtendItemPopup}>
                <ModalHeader>Extend User</ModalHeader>
                <ModalBody>
                    <Row><Col>
                        <p>Do you want to extend user access to this farm? If yes select the no of months to extend</p>
                    </Col></Row>
                    <Row>
                        <Col sm="6">
                            <Label className="label" for="months">Month(s)</Label>
                        </Col>
                        <Col sm="6">
                            <Input type="select" value={monthSelect} onChange={(e) => setMonthSelect(e.target.value)} name="months" id="months">
                                <option key={uuid()} value={0}>Select</option>
                                <option key={uuid()} value={1}>1</option>
                                <option key={uuid()} value={2}>2</option>
                                <option key={uuid()} value={3}>3</option>
                            </Input>
                            {formErrors.months != undefined &&
                                <p className="errorMessage">{formErrors.months}</p>
                            }
                        </Col></Row>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={confirmExtendItemPopup}>Yes</Button>
                    <Button color="danger" onClick={closeExtendItemPopup}>No</Button>
                </ModalFooter>
            </Modal>
            <Modal size="lg" isOpen={showInviteItemPopup}>
                <ModalHeader>Invite User</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label className="label" for="name">Email</Label>
                                <Input disabled={emailVerified} readOnly={emailVerified} type="text" className="validate" value={email} onChange={(e) => setEmail(e.target.value)} name="Email" id="Email" autoComplete="new-password" />
                            </FormGroup>
                            
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <label style={{fontSize:"18px",fontWeight:"750"}}>Search Result</label>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <hr />
                        </Col>
                    </Row>
                    {
                        userHasAccess &&
                        <>
                            <Row xs="3">
                                <Col>
                                    <FormGroup>
                                        <Label className="label" for="name">Firstname</Label>
                                        <input type="hidden" value={id} name="id" id="id"></input>
                                        <Input className="validate" readOnly={true} disabled={true} type="text" ref={userRef} value={firstName} name="FirstName" id="FirstName" autoComplete="new-password" />
                                    </FormGroup>
                                </Col>
                                <Col>
                                    <FormGroup>
                                        <Label className="label" for="name">Surname</Label>
                                        <Input type="text" value={surName} readOnly={true} disabled={true} name="surName" id="surName" autoComplete="new-password" />
                                    </FormGroup>
                                </Col>
                                <Col>
                                    <FormGroup>
                                        <Label className="label" for="name">Email</Label>
                                        <Input type="text" value={email} readOnly={true} disabled={true} name="email" id="email" autoComplete="new-password" />
                                    </FormGroup>
                                </Col>
                            </Row>
                        </>
                    }
                    {emailVerified &&
                        <>
                            {dataExists &&
                                <>
                                    <Row xs="3">
                                        <Col>
                                            <FormGroup>
                                                <Label className="label" for="name">Firstname</Label>
                                                <input type="hidden" value={id} name="id" id="id"></input>
                                                <Input className="validate" readOnly={true} disabled={true} type="text" ref={userRef} value={firstName} name="FirstName" id="FirstName" autoComplete="new-password" />
                                            </FormGroup>
                                        </Col>
                                        <Col>
                                            <FormGroup>
                                                <Label className="label" for="name">Surname</Label>
                                                <Input type="text" value={surName} readOnly={true} disabled={true} name="surName" id="surName" autoComplete="new-password" />
                                            </FormGroup>
                                        </Col>
                                        <Col>
                                            <FormGroup>
                                                <Label className="label" for="name">Email</Label>
                                                <Input type="text" value={email} readOnly={true} disabled={true} name="email" id="email" autoComplete="new-password" />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </>
                            }
                            {!dataExists &&
                            <>
                            <Row>
                                <Col>
                                    {formSuccess.email != undefined &&
                                        <p className="successMessage">{formSuccess.email}</p>
                                    }
                                </Col>
                            </Row>
                                    <Row xs="2">
                                        <Col>
                                            <FormGroup>
                                                <Label className="label" for="name">Firstname</Label>
                                                <input type="hidden" value={id} name="id" id="id"></input>
                                                <Input className="validate" readOnly={dataExists} disabled={dataExists} type="text" ref={userRef} value={firstName} onChange={(e) => setFirstName(e.target.value)} name="FirstName" id="FirstName" autoComplete="new-password" />
                                            </FormGroup>
                                            {formErrors.firstName != undefined &&
                                                <p className="errorMessage">{formErrors.firstName}</p>
                                            }
                                        </Col>
                                        <Col>
                                            <FormGroup>
                                                <Label className="label" for="name">Surname</Label>
                                                <Input type="text" value={surName} readOnly={dataExists} disabled={dataExists} onChange={(e) => setSurName(e.target.value)} name="surName" id="surName" autoComplete="new-password" />
                                            </FormGroup>
                                            {formErrors.surName != undefined &&
                                                <p className="errorMessage">{formErrors.surName}</p>
                                            }
                                        </Col>
                                    </Row>
                                    <Row xs="2">
                                        <Col>
                                            <FormGroup>
                                                <Label className="label" for="name">Email</Label>
                                                <Input type="text" value={email} readOnly={true} disabled={true} name="email" id="email" autoComplete="new-password" />
                                            </FormGroup>
                                        </Col>
                                        <Col>
                                            <FormGroup>
                                                <Label className="label" for="name">Mobile</Label>
                                                <Input type="tel" readOnly={dataExists} disabled={dataExists} value={mobile} onChange={(e) => setMobile(e.target.value.replace(/\D/, ''))} name="mobile" id="mobile" autoComplete="new-password" />
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </>
                            }
                            <Row xs="2">
                                <Col>
                                    <FormGroup>
                                        <Label className="label" for="name">Select Access Level</Label>
                                        {roles == undefined && <p><em>Loading...</em></p>}
                                        <Input className="validate" type="select" value={role} onChange={e => setRole(e.target.value)} name="Role" id="Role">
                                            <option key={uuid()} value="0">Select</option>
                                            <option key={uuid()} value="Complete">Complete</option>
                                            <option key={uuid()} value="Write">Write</option>
                                            <option key={uuid()} value="Read">Read</option>
                                        </Input>
                                    </FormGroup>
                                    {formErrors.role != undefined &&
                                        <p className="errorMessage">{formErrors.role}</p>
                                    }
                                </Col>
                                <Col>
                                <Row>
                                    <Col sm="12">
                                        <br />
                                        <div className="smart-description">
                                            <span className="smart-list" style={{ fontSize: "12px", fontWeight: "700" }}>
                                                Complete - full farm plan access / change settings / invite others
                                            </span>
                                            <span className="smart-list" style={{ fontSize: "12px", fontWeight: "700" }}>
                                                Write - full farm plan access
                                            </span>
                                            <span className="smart-list" style={{ fontSize: "12px", fontWeight: "700" }}>
                                                Read - full farm plan access but unable to make changes
                                            </span>
                                        </div>
                                    </Col>
                                </Row>
                                </Col>
                            </Row>
                        <Row xs="2">
                            <Col>
                                <Input type="checkbox" checked={temporaryAccess} onChange={(e) => setTemporaryAccess(e.target.checked)} name="conditions" id="conditions" />&nbsp;&nbsp;
                                <Label style={{ fontWeight: "700", fontSize: "14px", textTransform: "none" }}>Temporary Access</Label><br />
                            </Col>
                            {temporaryAccess &&
                                <Col>
                                    <FormGroup>
                                        <Label className="label" for="name">Month Access</Label>
                                        <Input type="select" value={monthSelect} onChange={(e) => setMonthSelect(e.target.value)} name="months" id="months">
                                            <option key={uuid()} value={0}>Select</option>
                                            <option key={uuid()} value={1}>1</option>
                                            <option key={uuid()} value={2}>2</option>
                                            <option key={uuid()} value={3}>3</option>
                                        </Input>
                                    </FormGroup>
                                    {formErrors.monthSelect != undefined &&
                                        <p className="errorMessage">{formErrors.monthSelect}</p>
                                    }
                                </Col>
                            }
                            
                        </Row>
                        </>
                    }
                    <Row>
                        <Col>
                            {formErrors.email != undefined &&
                                <p className="errorMessage">{formErrors.email}</p>
                            }
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button onClick={(e) => clearEmail(e)} className="btn btn-save btn btn-success"
                                style={{ backgroundColor: "#198754", borderColor: "#198754", float: "left" }}>
                                Reset
                            </Button>
                        </Col>
                        <Col>
                            <Button style={{ float: "right" }} color="danger" onClick={closeInviteItemPopup}>Cancel</Button>
                            {!emailVerified &&
                                <Button onClick={(e) => verifyEmail(e)} className="btn btn-save btn btn-success"
                                    style={{ backgroundColor: "#198754", borderColor: "#198754", float: "right" }}>
                                    <FaCheck />
                                    Check & Verify
                                </Button>
                            }
                            {emailVerified &&

                                <>
                                    {saving ?
                                        <Button onClick={confirmInviteItemPopup} style={{ float: "right" }} className="btn btn-save btn btn-success" disabled >
                                            <Row>
                                                <Col sm="9">
                                                    <span>
                                                        {' '}Saving
                                                    </span>
                                                </Col>
                                                <Col sm="3">
                                                    <Spinner size="sm">
                                                        Saving...
                                                    </Spinner>
                                                </Col>
                                            </Row>
                                        </Button>
                                        :
                                        <Button style={{ float: "right" }} onClick={confirmInviteItemPopup} className="btn btn-save btn btn-success" >
                                            Invite
                                        </Button>
                                    }
                                </>
                            }

                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>

                </ModalFooter>
            </Modal>
            <Modal isOpen={showSuccessPopup}>
                <ModalHeader>Success!</ModalHeader>
                <ModalBody>
                    <p>Access to this property has been successfully setup.</p>
                    <p>Please ask the user to login or check their email for confirmation</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="success" onClick={closeSuccessPopup}>Ok</Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={showSuccessPopup1}>
                <ModalHeader>Success!</ModalHeader>
                <ModalBody>
                    <p>Invitation to access this property has been successfully sent.</p>
                    <p>Please ask the user to check their email for details</p>
                </ModalBody>
                <ModalFooter>
                    <Button color="success" onClick={closeSuccessPopup1}>Ok</Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={showExtendItemPopup}>
                <ModalHeader>Extend User</ModalHeader>
                <ModalBody>
                    <Row><Col>
                        <p>Do you want to extend user access to this farm? If yes select the no of months to extend</p>
                    </Col></Row>
                    <Row>
                        <Col sm="6">
                            <Label className="label" for="months">Month(s)</Label>
                        </Col>
                        <Col sm="6">
                            <Input type="select" value={monthSelect} onChange={(e) => setMonthSelect(e.target.value)} name="months" id="months">
                                <option key={uuid()} value={0}>Select</option>
                                <option key={uuid()} value={1}>1</option>
                                <option key={uuid()} value={2}>2</option>
                                <option key={uuid()} value={3}>3</option>
                            </Input>
                            {formErrors.months != undefined &&
                                <p className="errorMessage">{formErrors.months}</p>
                            }
                        </Col></Row>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={confirmExtendItemPopup}>Yes</Button>
                    <Button color="danger" onClick={closeExtendItemPopup}>No</Button>
                </ModalFooter>
            </Modal>
        </div>
    );
}

export default AccessManager;
